import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((module) => module.LoginModule),
    pathMatch: 'full',
    canActivate: [LoginGuard],
  },

  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home-routing.module').then((module) => module.HomeRoutingModule),
  },

  {
    path: 'home-achievements',
    loadChildren: () =>
      import('./pages/home-achievements/home-achievements-routing.module').then(
        (module) => module.HomeAchievementsRoutingModule
      ),
  },
  {
    path: 'skillset-management',
    loadChildren: () =>
      import('./pages/skillset-management/skillset-management-routing.module').then(
        (module) => module.SkillsetManagementRoutingModule
      ),
  },

  {
    path: 'pragmatico/:id',
    loadChildren: () =>
      import('./pages/pragmatico/pragmatico-routing.module').then(
        (module) => module.PragmaticoRoutingModule
      ),
  },

  {
    path: 'edit-growth-map',
    loadChildren: () =>
      import('./pages/edit-growth-map/edit-growth-map-routing.module').then(
        (module) => module.EditGrowthMapRoutingModule
      ),
  },

  {
    path: 'growth-maps',
    loadChildren: () =>
      import('./pages/growth-maps/growth-maps-routing.module').then(
        (module) => module.GrowthMapsRoutingModule
      ),
  },

  {
    path: 'goal-groups',
    loadChildren: () =>
      import('./modules/goal-groups/goal-groups.module').then((module) => module.GoalGroupsModule),
  },

  {
    path: 'changelog',
    loadComponent: () =>
      import('./pages/changelog/changelog.component').then((m) => m.ChangelogComponent),
  },

  {
    path: 'person-groups',
    loadChildren: () =>
      import('./modules/person-groups/person-groups.module').then(
        (module) => module.PersonGroupsModule
      ),
  },

  {
    path: 'shopping-cart-skillset',
    loadChildren: () =>
      import('./pages/shopping-cart-skillset/shopping-cart-skillset-routing.module').then(
        (module) => module.ShoppingCartSkillsetModule
      ),
  },
  {
    path: 'technical-roles', // PADRE (sin componente) que agrupa la sección
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/technical-roles/technical-roles-routing.module').then(
            (m) => m.TechnicalRolesRoutingModule
          ),
      },
      {
        path: 'roles-catalog',
        loadChildren: () =>
          import('./pages/roles-catalog/roles-catalog-routing.module').then(
            (m) => m.RolesCatalogRoutingModule
          ),
      },
    ],
  },

  {
    path: ':id',
    loadChildren: () =>
      import('./pages/pragmatico/pragmatico-routing.module').then(
        (module) => module.PragmaticoRoutingModule
      ),
  },

  {
    path: '404',
    loadChildren: () => import('./pages/404/404.module').then((module) => module.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];

@NgModule({
  imports: [BrowserModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
